import React from 'react';
import PropTypes from 'prop-types';
import FieldValue from './FieldValue';
import { Button, Form } from '../index';
import './TagField.scss';

export default function TagField({
  style, label, value, onChange
}) {
  const add = (tag) => {
    if (value.indexOf(tag) === -1) {
      value.push(tag);
      onChange({
        target: {
          value,
        },
      });
    }
  };
  return (
    <FieldValue
      style={style}
      className="form-tag-field"
      label={label}
    >
      <Form values={{ tag: '' }} noHtmlForm>
        {({ values, getHandler, onChange: setValue }) => {
          return (
            <div>
              <input
                type="text"
                value={values.tag}
                onChange={getHandler('tag')}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    add(values.tag);
                    setValue('tag', '');
                  }
                }}
              />
              <Button
                className="add"
                onClick={(e) => {
                  e.preventDefault();
                  if (values.tag) {
                    add(values.tag);
                    setValue('tag', '');
                  }
                }}
              >
                <i className="material-icons">add</i>
              </Button>
            </div>
          );
        }}
      </Form>
      <div className="tags">
        {value.map((tag) => {
          return (
            <div className="tag" key={tag}>
              {tag}
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  value.splice(value.indexOf(tag), 1);
                  onChange({
                    target: {
                      value,
                    },
                  });
                }}
              >
                <i className="material-icons">close</i>
              </Button>
            </div>
          );
        })}
      </div>
    </FieldValue>
  );
}

TagField.propTypes = {
  style: PropTypes.shape(),
  label: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
};

TagField.defaultProps = {
  style: {},
  label: '',
  value: [],
};
